import { useMutation, useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { useToast } from "@/hooks/use-toast";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Loader2 } from "lucide-react";
import { graceBannerText, type GraceFields } from "@/lib/paymentGrace";

// Shown on every app page while the last renewal failed and the grace period runs (Mike 04.10., 7 days).
// Not dismissible: without a new card the access pauses at graceUntil.
export function PaymentGraceBanner() {
  const { toast } = useToast();
  const { data: user } = useQuery<GraceFields>({ queryKey: ["/api/auth/me"] });
  const portal = useMutation({
    mutationFn: () => apiRequest("POST", "/api/billing/portal", {}),
    onSuccess: (res: { url?: string }) => {
      if (res?.url) window.location.href = res.url;
      else toast({ title: "Fehler", description: "Der Link zum Kundenportal fehlt. Bitte versuchen Sie es erneut.", variant: "destructive" });
    },
    onError: (err: any) => {
      toast({ title: "Fehler", description: err?.data?.error || "Das Kundenportal ist gerade nicht erreichbar.", variant: "destructive" });
    },
  });
  const text = graceBannerText(user);
  if (!text) return null;
  return (
    <div role="alert" className="flex flex-col gap-2 border-b border-red-200 bg-red-50 px-4 py-3 sm:flex-row sm:items-center" data-testid="banner-payment-grace">
      <AlertTriangle className="hidden h-5 w-5 shrink-0 text-red-600 sm:block" aria-hidden="true" />
      <p className="flex-1 text-sm text-red-900">{text}</p>
      <Button size="sm" onClick={() => portal.mutate()} disabled={portal.isPending} data-testid="button-grace-update-payment">
        {portal.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : "Zahlungsmethode aktualisieren"}
      </Button>
    </div>
  );
}
